import { render, staticRenderFns } from "./Tccl3.vue?vue&type=template&id=fc0b4a90&scoped=true&"
import script from "./Tccl3.vue?vue&type=script&lang=js&"
export * from "./Tccl3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc0b4a90",
  null
  
)

export default component.exports